








import { IField } from './constants';

export default {
  props: {
    params: {
      default: () => ({}),
      type: Object,
    },
    value: [String, Number],
  },
  directives: {
    attributes($el: HTMLInputElement, { value }: { value: any }) {
      for (const name in value) {
        $el.setAttribute(name, value[name]);
      }
    },
  },
} as IField;
